import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const TitleColumns = () => (
    <>
        <GridTable.Data>
            <I18n component="span" id="debin.scheduled.table.creationDate" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="debin.scheduled.table.applicant" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="debin.scheduled.table.amount" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="debin.scheduled.table.installment" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="debin.status" />
        </GridTable.Data>
        <GridTable.Data />
    </>
);
export default TitleColumns;
